import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools } from 'zustand/middleware';
import { getServerTime } from '@/services/index.service';

const initialState = {
    error: null,
    isInit: false,
    intervalId: null,
    serverTime: Date.now()
};

let commonStore = (set, get) => ({
    ...initialState,
    init: async () => {
        if (get().isInit) return;
        set({ isInit: true });
        const { status, data } = await getServerTime();
        // reset() may have run while the request was in flight
        if (!get().isInit) return;

        const hasServerTime = status && data?.entity;
        set({
            serverTime: hasServerTime ? data.entity : Date.now(),
            error: hasServerTime ? null : 'error setting server time, defaulting to client time',
            intervalId: setInterval(() => {
                set((state) => { state.serverTime += 1000; });
            }, 1000)
        });
    },
    reset: () => {
        set((state) => {
            clearInterval(state.intervalId);
            return initialState;
        });
    },
    getServerTime: () => get().serverTime
});

commonStore = immer(commonStore);
commonStore = devtools(commonStore);

const useCommonStore = create(commonStore);

export default useCommonStore;
